import { getParameterByName } from "../helpers";

document.querySelectorAll('.c-quickfilter__text').forEach((item) =>
{
    const text = item.textContent.trim();
    const match = text.match(/^(.*?)\s*(\([^)]*\))$/);

    if (!match)
        return;

    const label = match[1];
    const size = match[2];

    item.innerHTML = `
        <span class="c-quickfilter__label">${label}</span>
        <span class="c-quickfilter__size">${size}</span>
    `;
});

// Get all active filters as property/option array.
export const getActiveFilters = (normalFilters: boolean, sliders: boolean, price: boolean, allFilters: boolean) =>
{
    var propertyAndOption = [];

    if (normalFilters)
    {
        // Get active filters and color filters.
        var activeFilters = $(".w-filter__sublist-item.checked");

        // Check for active filters.
        if (typeof activeFilters !== typeof (undefined) && activeFilters != null && activeFilters.length > 0)
        {
            activeFilters.each(function ()
            {
                // Add all active filters to array.
                var propertyID = $(this).data("property-id");
                var optionID = $(this).data("option-id");

                if (typeof propertyID !== typeof (undefined) && propertyID != null &&
                    typeof optionID !== typeof (undefined) && optionID != null)
                {
                    propertyAndOption.push([propertyID.toString(), optionID.toString()]);
                }
            });
        }
    }

    if (sliders)
    {
        var rangeFilters = $(".rangeslider.propertyslider");

        if (typeof rangeFilters !== typeof (undefined) && rangeFilters != null && rangeFilters.length > 0)
        {
            $(rangeFilters).each(function ()
            {
                var propertyName = $(this).find("input[name='prop-name']").val();

                if (typeof propertyName !== typeof (undefined) && propertyName != null)
                {
                    var currentMinValue = getParameterByName(propertyName + "-min");
                    var currentMaxValue = getParameterByName(propertyName + "-max");

                    if (typeof currentMinValue !== typeof (undefined) && currentMinValue != null && currentMinValue.length > 0)
                        propertyAndOption.push([propertyName + "-min", currentMinValue]);

                    if (typeof currentMaxValue !== typeof (undefined) && currentMaxValue != null && currentMaxValue.length > 0)
                        propertyAndOption.push([propertyName + "-max", currentMaxValue]);
                }
            });
        }
    }

    if (price)
    {
        var priceMin = getParameterByName("price-min");
        var priceMax = getParameterByName("price-max");

        if (typeof priceMin !== typeof (undefined) && priceMin != null && priceMin.length > 0)
            propertyAndOption.push(["price-min", priceMin]);

        if (typeof priceMax !== typeof (undefined) && priceMax != null && priceMax.length > 0)
            propertyAndOption.push(["price-max", priceMax]);
    }

    if (allFilters)
    {
        // Get active filters and color filters.
        var filters = $(".j-filter .w-filter__sublist input");

        // Check for active filters.
        if (typeof filters !== typeof (undefined) && filters != null && filters.length > 0)
        {
            filters.each(function ()
            {
                var filterItemRow = $(this).closest(".w-filter__sublist-item");

                // Add all active filters to array.
                if (typeof filterItemRow !== typeof (undefined) && filterItemRow != null && filterItemRow.length > 0)
                {
                    var propertyID = $(filterItemRow).data("property-id");
                    var optionID = $(filterItemRow).data("option-id");

                    if (typeof propertyID !== typeof (undefined) && propertyID != null &&
                        typeof optionID !== typeof (undefined) && optionID != null)
                    {
                        propertyAndOption.push([propertyID.toString(), optionID.toString()]);
                    }
                }
            });
        }
    }

    return propertyAndOption;
}

// TODO IMPLEMENT
export const createVirtualURL = () =>
{

}

document.addEventListener("DOMContentLoaded", () =>
{
    const productView = document.querySelector(".j-productview");
    const productCards = document.querySelectorAll(".w-productcard");

    if (productCards.length <= 0)
        return;

    const mobileThreshold = 768;
    let wasMobile = window.innerWidth <= mobileThreshold;

    function handleResize(): void
    {
        const isMobile = window.innerWidth <= mobileThreshold;

        if (wasMobile && !isMobile)
            productCards.forEach(card => card.classList.remove("w-productcard--small"));

        if (!wasMobile && isMobile)
        {
            const hasSingleColumn = productView?.classList.contains("c-productview--single-column");
            if (hasSingleColumn)
                productCards.forEach(card => card.classList.add("w-productcard--small"));
        }

        wasMobile = isMobile;
    }

    const isMobileOnInit = window.innerWidth <= mobileThreshold;

    if (!isMobileOnInit)
        productCards.forEach(card => card.classList.remove("w-productcard--small"));
    else if (productView?.classList.contains("c-productview--single-column"))
        productCards.forEach(card => card.classList.add("w-productcard--small"));

    window.addEventListener("resize", handleResize);
});
